export default __webpack_public_path__ + "static/media/menu_icon.340e3b4a.svg";